import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetConsolidationRuleSetQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetConsolidationRuleSetQuery = { __typename?: 'Query', consolidationRuleSet?: { __typename?: 'ConsolidationRuleSetDocument', id: string, tenantId: string, minimumLotQuantity: number, lookBackWeeks: number, lookForwardWeeks: number, direction: Types.ConsolidationDirection, roundingUnit?: number | null, customerGrouping: Types.ConsolidationCustomerGrouping, locationGrouping: Types.ConsolidationLocationGrouping, lastModified?: Types.TDateISO | null } | null };

export type GetConsolidationPreviewQueryVariables = Types.Exact<{
  input: Types.ConsolidationPreviewInput;
}>;


export type GetConsolidationPreviewQuery = { __typename?: 'Query', consolidationPreview: { __typename?: 'ConsolidationPreviewPayload', success: boolean, consolidationPreview?: { __typename?: 'ConsolidationPreviewData', weeks: Array<Types.TDateISO>, rows: Array<{ __typename?: 'ConsolidationPreviewRowData', level: Types.ConsolidationPreviewRollupLevel, productionCatalogId?: string | null, genusCode?: string | null, categoryGroup?: string | null, cells: Array<{ __typename?: 'ConsolidationPreviewCellData', weekStart: Types.TDateISO, totalQty: number, rawTotalQty: number, jobCount: number, sourceJobIds: Array<string>, efficiencyFlag: Types.ConsolidationPreviewEfficiencyFlag, demandEstimated: boolean }> }>, ruleContext: { __typename?: 'ConsolidationPreviewRuleSetContextData', minimumLotQuantity: number, roundingUnit?: number | null, fromTenantOverride: boolean } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ConsolidationRuleSetDocumentFieldsFragment = { __typename?: 'ConsolidationRuleSetDocument', id: string, tenantId: string, minimumLotQuantity: number, lookBackWeeks: number, lookForwardWeeks: number, direction: Types.ConsolidationDirection, roundingUnit?: number | null, customerGrouping: Types.ConsolidationCustomerGrouping, locationGrouping: Types.ConsolidationLocationGrouping, lastModified?: Types.TDateISO | null };

export type ConsolidationPreviewFieldsFragment = { __typename?: 'ConsolidationPreviewData', weeks: Array<Types.TDateISO>, rows: Array<{ __typename?: 'ConsolidationPreviewRowData', level: Types.ConsolidationPreviewRollupLevel, productionCatalogId?: string | null, genusCode?: string | null, categoryGroup?: string | null, cells: Array<{ __typename?: 'ConsolidationPreviewCellData', weekStart: Types.TDateISO, totalQty: number, rawTotalQty: number, jobCount: number, sourceJobIds: Array<string>, efficiencyFlag: Types.ConsolidationPreviewEfficiencyFlag, demandEstimated: boolean }> }>, ruleContext: { __typename?: 'ConsolidationPreviewRuleSetContextData', minimumLotQuantity: number, roundingUnit?: number | null, fromTenantOverride: boolean } };

export type ConsolidationPreviewRowFieldsFragment = { __typename?: 'ConsolidationPreviewRowData', level: Types.ConsolidationPreviewRollupLevel, productionCatalogId?: string | null, genusCode?: string | null, categoryGroup?: string | null, cells: Array<{ __typename?: 'ConsolidationPreviewCellData', weekStart: Types.TDateISO, totalQty: number, rawTotalQty: number, jobCount: number, sourceJobIds: Array<string>, efficiencyFlag: Types.ConsolidationPreviewEfficiencyFlag, demandEstimated: boolean }> };

export type ConsolidationPreviewCellFieldsFragment = { __typename?: 'ConsolidationPreviewCellData', weekStart: Types.TDateISO, totalQty: number, rawTotalQty: number, jobCount: number, sourceJobIds: Array<string>, efficiencyFlag: Types.ConsolidationPreviewEfficiencyFlag, demandEstimated: boolean };

export type ConsolidationRuleContextFieldsFragment = { __typename?: 'ConsolidationPreviewRuleSetContextData', minimumLotQuantity: number, roundingUnit?: number | null, fromTenantOverride: boolean };

export const ConsolidationRuleSetDocumentFieldsFragmentDoc = new TypedDocumentString(`
    fragment ConsolidationRuleSetDocumentFields on ConsolidationRuleSetDocument {
  id
  tenantId
  minimumLotQuantity
  lookBackWeeks
  lookForwardWeeks
  direction
  roundingUnit
  customerGrouping
  locationGrouping
  lastModified
}
    `, {"fragmentName":"ConsolidationRuleSetDocumentFields"});
export const ConsolidationPreviewCellFieldsFragmentDoc = new TypedDocumentString(`
    fragment ConsolidationPreviewCellFields on ConsolidationPreviewCellData {
  weekStart
  totalQty
  rawTotalQty
  jobCount
  sourceJobIds
  efficiencyFlag
  demandEstimated
}
    `, {"fragmentName":"ConsolidationPreviewCellFields"});
export const ConsolidationPreviewRowFieldsFragmentDoc = new TypedDocumentString(`
    fragment ConsolidationPreviewRowFields on ConsolidationPreviewRowData {
  level
  productionCatalogId
  genusCode
  categoryGroup
  cells {
    ...ConsolidationPreviewCellFields
  }
}
    fragment ConsolidationPreviewCellFields on ConsolidationPreviewCellData {
  weekStart
  totalQty
  rawTotalQty
  jobCount
  sourceJobIds
  efficiencyFlag
  demandEstimated
}`, {"fragmentName":"ConsolidationPreviewRowFields"});
export const ConsolidationRuleContextFieldsFragmentDoc = new TypedDocumentString(`
    fragment ConsolidationRuleContextFields on ConsolidationPreviewRuleSetContextData {
  minimumLotQuantity
  roundingUnit
  fromTenantOverride
}
    `, {"fragmentName":"ConsolidationRuleContextFields"});
export const ConsolidationPreviewFieldsFragmentDoc = new TypedDocumentString(`
    fragment ConsolidationPreviewFields on ConsolidationPreviewData {
  weeks
  rows {
    ...ConsolidationPreviewRowFields
  }
  ruleContext {
    ...ConsolidationRuleContextFields
  }
}
    fragment ConsolidationPreviewRowFields on ConsolidationPreviewRowData {
  level
  productionCatalogId
  genusCode
  categoryGroup
  cells {
    ...ConsolidationPreviewCellFields
  }
}
fragment ConsolidationPreviewCellFields on ConsolidationPreviewCellData {
  weekStart
  totalQty
  rawTotalQty
  jobCount
  sourceJobIds
  efficiencyFlag
  demandEstimated
}
fragment ConsolidationRuleContextFields on ConsolidationPreviewRuleSetContextData {
  minimumLotQuantity
  roundingUnit
  fromTenantOverride
}`, {"fragmentName":"ConsolidationPreviewFields"});
export const GetConsolidationRuleSetDocument = new TypedDocumentString(`
    query GetConsolidationRuleSet {
  consolidationRuleSet {
    ...ConsolidationRuleSetDocumentFields
  }
}
    fragment ConsolidationRuleSetDocumentFields on ConsolidationRuleSetDocument {
  id
  tenantId
  minimumLotQuantity
  lookBackWeeks
  lookForwardWeeks
  direction
  roundingUnit
  customerGrouping
  locationGrouping
  lastModified
}`);
export const GetConsolidationPreviewDocument = new TypedDocumentString(`
    query GetConsolidationPreview($input: ConsolidationPreviewInput!) {
  consolidationPreview(input: $input) {
    consolidationPreview {
      ...ConsolidationPreviewFields
    }
    errors {
      code
      message
    }
    success
  }
}
    fragment ConsolidationPreviewFields on ConsolidationPreviewData {
  weeks
  rows {
    ...ConsolidationPreviewRowFields
  }
  ruleContext {
    ...ConsolidationRuleContextFields
  }
}
fragment ConsolidationPreviewRowFields on ConsolidationPreviewRowData {
  level
  productionCatalogId
  genusCode
  categoryGroup
  cells {
    ...ConsolidationPreviewCellFields
  }
}
fragment ConsolidationPreviewCellFields on ConsolidationPreviewCellData {
  weekStart
  totalQty
  rawTotalQty
  jobCount
  sourceJobIds
  efficiencyFlag
  demandEstimated
}
fragment ConsolidationRuleContextFields on ConsolidationPreviewRuleSetContextData {
  minimumLotQuantity
  roundingUnit
  fromTenantOverride
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetConsolidationRuleSet: build.query<GetConsolidationRuleSetQuery, GetConsolidationRuleSetQueryVariables | void>({
      query: (variables) => ({ document: GetConsolidationRuleSetDocument, variables })
    }),
    GetConsolidationPreview: build.query<GetConsolidationPreviewQuery, GetConsolidationPreviewQueryVariables>({
      query: (variables) => ({ document: GetConsolidationPreviewDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetConsolidationRuleSetQuery, useLazyGetConsolidationRuleSetQuery, useGetConsolidationPreviewQuery, useLazyGetConsolidationPreviewQuery } = injectedRtkApi;
